import { debounce } from '@titanio/utils'

const classname = {
  hidden: 'is-hidden',
  arrow: '.js-navbar-arrow',
  scrollbar: '.js-navbar-scrollbar',
  container: '.js-navbar-container',
  arrowLeft: '.js-navbar-arrow-left',
  arrowRight: '.js-navbar-arrow-right',
}

const isMobile = () => {
  const match = window.matchMedia('(pointer:coarse)')
  return match && match.matches
}

const configs = {
  viewport: 768,
  gutter: 48,
}

let scrollLeft = 0
const selectors = {}

const mount = () => {
  scrollLeft = 0
  if (isMobile()) return

  /**
   * checks if there is a scrollbar
   */

  selectors.scrollbar = document.querySelector(classname.scrollbar)
  if (!selectors.scrollbar) return

  /**
   * selects remaining elements for operation
   */

  selectors.container = document.querySelector(classname.container)
  selectors.arrowLeft = document.querySelector(classname.arrowLeft)
  selectors.arrowRight = document.querySelector(classname.arrowRight)

  /**
   * checks which buttons should appear
   */
  toggleButtons()

  /**
   * delegate click event
   */
  document.addEventListener(
    'click',
    ({ target }) => {
      const bubblingTarget = target.closest(classname.arrow)
      if (!bubblingTarget) return

      /**
       * get scroll direction
       */
      const { direction } = bubblingTarget.dataset

      scrollLeft = direction === 'left' ? scrollLeft - 200 : scrollLeft + 200
      selectors.scrollbar.scrollLeft = scrollLeft
      toggleButtons()
    },
    false
  )

  /**
   * check buttons on resize
   */
  window.addEventListener('resize', debounce(toggleButtons, 100))
}

const toggleButtons = () => {
  if (window.innerWidth >= configs.viewport) {
    const wrapperWidth = selectors.scrollbar.clientWidth
    const scrollWidthValue = selectors.scrollbar.scrollWidth

    const showArrowLeft = scrollLeft > 0
    const showArrowRight = scrollLeft + wrapperWidth < scrollWidthValue

    selectors.arrowLeft.classList.toggle(classname.hidden, !showArrowLeft)
    selectors.arrowRight.classList.toggle(classname.hidden, !showArrowRight)
  }
}

export default { mount }
